import { Chip, Typography } from "@mui/material";
import useColors from "../../../../api/hooks/useColors";

const JiraPriorityLabel = ({ priority }) => {
  const colors = useColors();
  let label = "";
  let backgroundColor = colors.cve_high;
  let color = colors.common_white;
  switch (priority) {
    case "High":
      backgroundColor = colors.tracking_high;
      label = "High";
      break;
    case "Medium":
      backgroundColor = colors.tracking_medium;
      label = "Medium";
      break;
    case "Low":
      backgroundColor = colors.tracking_low;
      label = "Low";
      break;
    case "Highest":
      backgroundColor = colors.tracking_critical;
      label = "Highest";
      break;
    case "Triage":
      backgroundColor = colors.grey_500;
      label = "Triage";
      break;
    default:
      backgroundColor = colors.tracking_low;
      label = priority;
      break;
  }

  return (
    <Chip
      label={<Typography variant="overline">{label}</Typography>}
      style={{
        backgroundColor: backgroundColor,
        color: color,
        width: "70px",
        borderRadius: "8px",
        padding: "6px",
      }}
      sx={{
        "& .MuiChip-label": {
          padding: 0,
        },
      }}
    />
  );
};

export default JiraPriorityLabel;
